/* global G */
import { asyncpipe, setKey } from 'lib/util'
import cancelOnError from 'lib/sequence/model/cancelOnError'
import create from 'lib/sequence/model/api/create'
import read from 'lib/sequence/model/api/read'
import reset from 'lib/sequence/model/api/reset'
import { empty } from 'lib/util/object'

const descriptor = 'sequence::model::refresh'

const component = {
  [G.CHILDREN]: [],
}

/**
 * Regenerates `obj`'s cache from its own state data.
 *
 * @param {Gaia.Model.Spec} obj         the model object composition
 * @returns {Promise<Gaia.Model.Spec>}  the updated model
 */
const refreshFromStateData = async (obj) => {
  create(obj)
  // transform(obj)
  const data = obj[G.STATE][G.DATA]
  const cache = !empty(data) ? data : null
  setKey(cache, G.CACHE, obj)
  await read(obj)(component)
  return obj
}

/**
 * Regenerates `obj`'s cache from data.
 *
 * @param {Gaia.Model.Spec} obj the model object composition
 * @param {Object} item         the data to set as the model's cache
 * @param {string} item.key     the key to set as the model's key
 * @param {Object} [options]    {@link reset} options
 * @returns {function({key: *, data?: *}): Promise<Gaia.Model.Spec>} the updated model
 */
const refreshFromData = async (obj, { key, ...data }, options) => {
  reset(obj, options)
  const cache = !empty(data) ? { key, ...data } : null
  setKey(cache, G.CACHE, obj)
  setKey(key || null, G.REF, obj[G.STATE])
  await read(obj)(component)
  return obj
}

/**
 * Regenerates `obj`'s cache from `item` or from its own state data, if no
 * `item` is passed.
 *
 * @param {Gaia.Model.Spec} obj       the model object composition to regenerate the cache to
 * @param {Object} [item]             data to fill the model's cache with, instead of its state data
 * @param {Object} [options]          {@link reset} options, executed with model if `item` is passed
 * @returns {Promise<Gaia.Model.Spec>}  the updated model
 */
const refresh = async (obj, item, options) => await asyncpipe(
  cancelOnError(descriptor),
  async model => (item
    ? await refreshFromData(model, item, options)
    : await refreshFromStateData(model)),
)(obj)

export default refresh
